import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKeys } from 'localization';

import { Modal, Button, Flex, H3, M } from 'design-system-web';

import styles from './FeedbackAlreadySubmittedModal.scss';

const TRANSLATION_KEYS: { [key: string]: TranslationKeys } = Object.freeze({
  title: 'web.member.serviceRequest.feedback.alreadySubmitted.title',
  body: 'web.member.serviceRequest.feedback.alreadySubmitted.body',
  gotIt: 'web.member.serviceRequest.feedback.alreadySubmitted.acknowledge',
});

type FeedbackAlreadySubmittedModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const FeedbackAlreadySubmittedModal = ({
  isOpen,
  onClose,
}: FeedbackAlreadySubmittedModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeButtonSize="small"
      disableContentPadding
    >
      <Flex direction="column" className={styles.container}>
        <header className={styles.header}>
          <H3>{t(TRANSLATION_KEYS.title)}</H3>
        </header>
        <main className={styles.body}>
          <M>{t(TRANSLATION_KEYS.body)}</M>
        </main>
        <footer className={styles.footer}>
          <div className={styles.buttonContainer}>
            <Button variant="primary" onClick={onClose} size="large">
              {t(TRANSLATION_KEYS.gotIt)}
            </Button>
          </div>
        </footer>
      </Flex>
    </Modal>
  );
};
